import { Dispatch } from 'react'

import { RequirePasswordDialogState } from './store/State'

import { setIsDialogOpen, setPassword, setIsValidPassword, RequirePasswordDialogAction } from './store/Actions'

import SignInService from 'smart-components/sign-in/Service'

export default class RequirePasswordDialogService {
  static toggleDialog(state: RequirePasswordDialogState, dispatch: Dispatch<RequirePasswordDialogAction>) {
    return () => {
      dispatch(setIsDialogOpen(!state.isDialogOpen))
    }
  }

  static setPassword(state: RequirePasswordDialogState, dispatch: Dispatch<RequirePasswordDialogAction>) {
    return (password: string) => {
      if (state.password !== password) {
        dispatch(setPassword(password))
      }
    }
  }

  static checkPassword(state: RequirePasswordDialogState, dispatch: Dispatch<RequirePasswordDialogAction>) {
    return () => {
      const isValidPassword = SignInService.isValidPassword(state.password)

      if (isValidPassword !== state.isValidPassword) {
        dispatch(setIsValidPassword(isValidPassword))
      }
    }
  }

  static checkSubmission(state: RequirePasswordDialogState, dispatch: Dispatch<RequirePasswordDialogAction>) {
    return (): boolean => {
      const isValidPassword = SignInService.isValidPassword(state.password)

      if (isValidPassword !== state.isValidPassword) {
        dispatch(setIsValidPassword(isValidPassword))
      }

      return isValidPassword
    }
  }
}
